"use client";
import { jsx } from "react/jsx-runtime";
import { DropdownTextItem } from "../../primitive-dropdown/dropdown-text-item.js";
import { GenericDropdown } from "./generic-dropdown.js";
function TextsDropdown({ options, multiline, ...props }) {
    const textOptions = options.map((option)=>({
            value: option.value,
            label: option.label,
            description: option.description,
            element: (elementProps)=>/*#__PURE__*/ jsx(DropdownTextItem, {
                    text: option.label,
                    description: option.description,
                    multiline: multiline,
                    ...elementProps
                })
        }));
    return /*#__PURE__*/ jsx(GenericDropdown, {
        ...props,
        multiline: multiline,
        options: textOptions
    });
}
export { TextsDropdown };
